export default __webpack_public_path__ + "static/media/Icon-feather-search-primary-color.5abe5b39.svg";